import usePhoneClosure from '@/hooks/usePhoneClosure';

export default function PhoneClosureNotice({ en = false }) {
  const closed = usePhoneClosure();
  if (!closed) return null;
  return (
    <div role="status" className="bg-ee-brand text-ee-on-brand px-4 py-3 text-center text-sm leading-relaxed">
      {en ? 'Our phone lines are closed today, Friday 30 October.' : 'Telefonerne er lukket i dag, fredag den 30. oktober.'}
    </div>
  );
}